import {SearchItem, SearchResultDto} from "./search-table.dto.res";
import {DeathDto} from "../death.dto";

export class SearchDeathRes extends SearchResultDto {

  public override readonly items: SearchDeathItem[] = [];

  constructor(init?: Partial<SearchDeathRes>) {
    super(init);
    if (init?.items) {
      this.items = init.items.map((i) => new SearchDeathItem(i));
    } else {
      this.items = [];
    }
  }
}

export class SearchDeathItem extends DeathDto implements SearchItem {

  public readonly deceasedNumber!: string;
  public readonly deceasedFullName!: string;
  public readonly debtorNumber: string | undefined;
  public readonly debtorFullName!: string | undefined;
  public readonly placeOfDeathStreetFull!: string | undefined;
  public readonly placeOfDeathZipCode!: string | undefined;
  public readonly placeOfDeathCity!: string | undefined;

  constructor(init?: Partial<SearchDeathItem>) {
    super(init);
    Object.assign(this, init);
  }
}
